import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateChange'
})
export class dateChange implements PipeTransform {
  transform(date: any): string {

    if (date.includes("pm") || date.includes("am")) {
      var result = date.replace(/^0(?:0:0?)?/, '');
      return result;  
    }
    else {
      let get_date = new Date(date);
      var offset = get_date.getTimezoneOffset();
      var cstDateTime = new Date(get_date.getTime() + offset * 60000);
      const months = [
        "January",
        "Febuary",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      let m_string = months[cstDateTime.getMonth()];
      let m_date = cstDateTime.getDate();
      let m_year = cstDateTime.getFullYear();
      let day = m_date.toString();

      if (day == "1" || day == "21" || day == "31") {
        day = m_date + "st";
      } else if (day == "3" || day == "23") {
        day = m_date + "rd";
      } else if (day == "2" || day == "22") {
        day = m_date + "nd";
      } else {
        day = m_date + "th";
      }
      return `${m_string} ${day}, ${m_year} @`;
    }
  }
}